const langs = {
  en: {
    from: {
      label: 'Flying from',
      placeholder: 'Airport, city...'
    },
    to: {
      label: 'Flying to',
      placeholder: 'Airport, city...'
    },
    journeyTypes: [
      { id: 'rt', name: 'Return' },
      { id: 'ow', name: 'One way' },
      { id: 'oj', name: 'Multicity' }
    ],
    departureDate: {
      label: 'Departure date',
      placeholder: 'day.month.year'
    },
    returnDate: {
      label: 'Return date',
      placeholder: 'day.month.year'
    },
    adultsLabel: 'Adults',
    childrenLabel: 'Children',
    infantsLabel: 'Infants',
    submitText: 'Find flights',
    promo: {
      label: 'Promo code'
    }
  },

  es: {
    from: {
      label: 'Salida de',
      placeholder: 'Aeropuerto, ciudad y...'
    },
    to: {
      label: 'Llegada a',
      placeholder: 'Aeropuerto, ciudad y...'
    },
    journeyTypes: [
      { id: 'rt', name: 'Regreso' },
      { id: 'ow', name: 'Sólo ida' },
      { id: 'oj', name: 'Múltiples Ciudades' }
    ],
    departureDate: {
      label: 'Fecha de salida',
      placeholder: 'día/mes/año'
    },
    returnDate: {
      label: 'Fecha de regreso',
      placeholder: 'día/mes/año'
    },
    adultsLabel: 'Adultos',
    childrenLabel: 'Niños',
    infantsLabel: 'Bebés',
    submitText: 'Buscar vuelos',
    promo: {
      label: 'Código promocional'
    }
  },

  fr: {
    from: {
      label: 'Vol au départ de',
      placeholder: 'Aéroport, ville...'
    },
    to: {
      label: 'Vol à destination',
      placeholder: 'Aéroport, ville...'
    },
    journeyTypes: [
      { id: 'rt', name: 'Retour' },
      { id: 'ow', name: 'Aller simple' },
      { id: 'oj', name: 'Retour de/à un autre aéroport' }
    ],
    departureDate: {
      label: 'Dat de départ',
      placeholder: 'jour/mois/année'
    },
    returnDate: {
      label: 'Date du retour',
      placeholder: 'jour/mois/année'
    },
    adultsLabel: 'Adulte',
    childrenLabel: 'Enfants',
    infantsLabel: 'Bébés',
    submitText: 'Chercher un vol',
    promo: {
      label: 'Code promotionnel'
    }
  },

  sk: {
    from: {
      label: 'Odlet z',
      placeholder: 'Letisko, mesto...'
    },
    to: {
      label: 'Prílet do',
      placeholder: 'Letisko, mesto...'
    },
    journeyTypes: [
      { id: 'rt', name: 'Spiatočná' },
      { id: 'ow', name: 'Jednosmerná' },
      { id: 'oj', name: 'Iný návrat' }
    ],
    departureDate: {
      label: 'Dátum odletu',
      placeholder: 'deň.mesiac.rok'
    },
    returnDate: {
      label: 'Dátum návratu',
      placeholder: 'deň.mesiac.rok'
    },
    adultsLabel: 'Dospelí',
    childrenLabel: 'Deti',
    infantsLabel: 'Kojenci',
    submitText: 'Vyhľadať',
    promo: {
      label: 'Promo kód'
    }
  },

  it: {
    from: {
      label: 'Vola da',
      placeholder: 'Aeroporto, città'
    },
    to: {
      label: 'Vola a',
      placeholder: 'Aeroporto, città'
    },
    journeyTypes: [
      { id: 'rt', name: 'Ritorno' },
      { id: 'ow', name: 'Solo andata' },
      { id: 'oj', name: 'Combinazione città' }
    ],
    departureDate: {
      label: 'Data di partenza',
      placeholder: 'Giorno.Mese.Anno'
    },
    returnDate: {
      label: 'Data di ritorno',
      placeholder: 'Giorno.Mese.Anno'
    },
    adultsLabel: 'Adulti',
    childrenLabel: 'Bambini',
    infantsLabel: 'Infanti',
    submitText: 'Trovo un volo',
    promo: {
      label: 'Codice promozionale'
    }
  },

  ru: {
    from: {
      label: 'вылетать из',
      placeholder: 'аэропорт, город'
    },
    to: {
      label: ' лететь в',
      placeholder: 'аэропорт, город'
    },
    journeyTypes: [
      { id: 'rt', name: 'обратный' },
      { id: 'ow', name: 'односторонний' },
      { id: 'oj', name: '' }
    ],
    departureDate: {
      label: 'дата вылета',
      placeholder: 'день.месяц.год'
    },
    returnDate: {
      label: 'дата возвращения',
      placeholder: 'день.месяц.год'
    },
    adultsLabel: 'взрослые',
    childrenLabel: 'ребенки',
    infantsLabel: 'грудные рыбенки',
    submitText: 'найти рейс',
    promo: {
      label: 'Промокод'
    }
  },

  cs: {
    from: {
      label: 'Odlet z',
      placeholder: 'Letiště, město...'
    },
    to: {
      label: 'Přílet do',
      placeholder: 'Letiště, město...'
    },
    journeyTypes: [
      { id: 'rt', name: 'Zpáteční' },
      { id: 'ow', name: 'Jednosměrná' },
      { id: 'oj', name: 'Jiný návrat' }
    ],
    departureDate: {
      label: 'Datum odletu',
      placeholder: 'den.měsíc.rok'
    },
    returnDate: {
      label: 'Datum příletu',
      placeholder: 'den.měsíc.rok'
    },
    adultsLabel: 'Dospělý',
    childrenLabel: 'Dítě (2-11 let)',
    infantsLabel: 'Dítě do 2 let',
    submitText: 'Najít lety',
    promo: {
      label: 'Promo kód'
    }
  },

  de: {
    from: {
      label: 'Abflug ab',
      placeholder: 'Flughafen, Stadt ...'
    },
    to: {
      label: 'Fliegen nach',
      placeholder: 'Flughafen, Stadt ...'
    },
    journeyTypes: [
      { id: 'rt', name: 'Rückflug' },
      { id: 'ow', name: 'Einzelflug' },
      { id: 'oj', name: 'Andere Rückkehr' }
    ],
    departureDate: {
      label: 'Abflugdatum',
      placeholder: 'Tag.Monat.Jahr'
    },
    returnDate: {
      label: 'Rückflugdatum',
      placeholder: 'Tag.Monat.Jahr'
    },
    adultsLabel: 'Erwachsene',
    childrenLabel: 'Kinder',
    infantsLabel: 'Säuglinge',
    submitText: 'Flug suchen',
    promo: {
      label: 'Gutscheinkode'
    }
  }
}

const lang = (code) => langs[code] || langs['cs']

export default lang



/** WEBPACK FOOTER **
 ** ./src/lang.js
 **/